'use strict';

import ApiEndpoint from './api_endpoint';

export default class DestroyProtocolSubscription extends ApiEndpoint {
  execute(callback = undefined, session = undefined, externalIdentifier = '') {
    if (session === undefined) {
      return this.session.delete('/protocol_subscriptions/' + externalIdentifier, undefined, callback);
    }
    return session.delete('/protocol_subscriptions/' + externalIdentifier, undefined, callback);
  }
}
